import React from 'react';
import PropTypes from 'prop-types';

import RenderComponentProto from '../../render-component-proto';
import InputInlineEditable from 'core/gd-components/input-inline-editable/input-inline-editable';

export default class NumberComponentProto extends RenderComponentProto {

    static propTypes = {
        id: PropTypes.string.isRequired,
        renderMode: PropTypes.oneOf(['list','view','edit','form-new']).isRequired,
        value: PropTypes.any,
        canEdit: PropTypes.bool,
        onChange: PropTypes.func,
    };

    static defaultProps = {
        canEdit: false
    };

    state = {
        value: this.props.value,
        invalidValue: false,
        isEditing: false
    }

    constructor(props) {
        super(props);

        this.commited = true;
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.commited && this.state.value !== newProps.value) {
            this.updateValue(newProps.value);
        }
    }

    updateValue(val) {
        this.setState({
            value: val,
            invalidValue: !(_.isNil(val) || !isNaN(val) || val.length === 0)
        });
    }

    onFocus = (e) => {
        this.setState({isEditing: true}, () => {
            if (this.props.onFocus) this.props.onFocus(e)
        });
    }

    onBlur = (e) => {
        this.setState({isEditing: false}, () => {
            if (this.props.onBlur) this.props.onBlur(e);
        });
    }

    onChange = (newValue) => {
        this.commited = true;

        if (!isNaN(newValue) || newValue.length === 0) {
            if (this.props.onChange) this.props.onChange(parseFloat(newValue));
        }
    }

    onImmediateChange = (newValue) => {
        this.commited = false;
        this.updateValue(newValue);
    }

    getNormalizedValue = () => {
        if (this.state.invalidValue) return null;

        const cf = gd.session.customFields.get(this.props.id);
        const decimalPlaces = cf.params ? cf.params.decimalPlaces : 0;

        const normalized = typeof this.state.value === 'number' ?
            this.state.value.toFixed(decimalPlaces)
            :
            parseFloat(this.state.value).toFixed(decimalPlaces);

        return isNaN(normalized) ? null : normalized;
    }

    render() {
        const normalizedValue = this.getNormalizedValue();

        let classes;
        if (this.props.renderMode === 'edit') {
            classes = Classes('gd-field-number', 'view', 'edit', {
                'invalid-value': this.state.invalidValue,
                'disabled': this.props.canEdit === false,
            });
        } else {
            classes = Classes('gd-field-number', this.props.renderMode, {
                'edit': this.state.isEditing,
                'invalid-value': this.state.invalidValue,
                'disabled': this.props.canEdit === false,
                'not-set': !normalizedValue
            });
        }


        const borderComponent = normalizedValue && this.props.renderMode === 'list' && !this.state.isEditing ? <div className="value-border">{normalizedValue}</div> : null

        return (
            <div className={classes}>
                <InputInlineEditable value={normalizedValue}
                                     disabled={(this.props.canEdit === false)}
                                     onFocus={this.onFocus}
                                     onBlur={this.onBlur}
                                     onChange={this.onChange}
                                     onImmediateChange={this.onImmediateChange}
                                     commitDelay={this.props.commitDelay} />
                {borderComponent}
            </div>
        );
    }
}